export default function Button() {
  return {
    controlHeight: 45,
    controlHeightLG: 54
  }
}
